<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="24" height="24" fill="white" fill-opacity="0.01"/>
<path d="M3.00001 6.009C3.00001 4.899 3.89301 4 4.99501 4H19.005C20.107 4 21 4.902 21 6.009V13.991C21 15.101 20.107 16 19.005 16H4.99501C4.46421 15.9976 3.95603 15.7847 3.58201 15.4081C3.20799 15.0315 2.99868 14.5218 3.00001 13.991V6.009ZM5.00001 14H19V6H5.00001V14Z" fill="#42526E"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10 17H14V20H10V17ZM9.00001 20.5C8.99998 20.3689 9.05143 20.2431 9.14326 20.1496C9.23509 20.0561 9.35996 20.0024 9.49101 20H14.509C14.64 20.0024 14.7649 20.0561 14.8568 20.1496C14.9486 20.2431 15 20.3689 15 20.5V21H9.00001V20.5Z" fill="#42526E"/>
</svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
